import { BaseballIcon, BasketballIcon, SoccerIcon } from "@roman/shared/components/Icons";
import type { SportIcon } from "@roman/shared/types/SportIcon";

export type League = {
  seasonId: string;
  name: string;
};

export type Tab = {
  type: "popular" | "all" | "influencer";
  title: string;
};

export const TABS: Tab[] = [
  {
    type: "popular",
    title: "人気の大会",
  },
  {
    type: "all",
    title: "すべての大会",
  },
];

export const HIGH_PRIZE_POOL = 0;

export const LEAGUES: League[] = [
  {
    seasonId: "all",
    name: "すべて",
  },
  {
    seasonId: "sr:season:118689",
    name: "プレミアリーグ",
  },
  {
    seasonId: "sr:season:118691",
    name: "ラ・リーガ",
  },
  {
    seasonId: "sr:season:118975",
    name: "セリエA",
  },
  {
    seasonId: "sr:season:118693",
    name: "ブンデスリーガ",
  },
  {
    seasonId: "sr:season:119835",
    name: "リーグ1",
  },
  {
    seasonId: "sr:season:119239",
    name: "UEFAチャンピオンズリーグ",
  },
  {
    seasonId: "sr:season:115715",
    name: "ネーションズリーグ",
  },
  {
    seasonId: "sr:season:114057",
    name: "ワールドカップ予選",
  },
  {
    seasonId: "sr:season:127083",
    name: "Jリーグ",
  },
  {
    seasonId: "sr:season:119781",
    name: "UEFAヨーロッパリーグ",
  },
];

export type Sport = {
  id: number;
  icon: React.FC<SportIcon>;
  title: string;
};

export const SPORTS: Sport[] = [
  {
    id: 1,
    icon: SoccerIcon,
    title: "サッカー",
  },
  {
    id: 2,
    icon: BaseballIcon,
    title: "野球",
  },
  {
    id: 3,
    icon: BasketballIcon,
    title: "バスケットボール",
  },
];
